import { Moon, Music, Users } from "lucide-react";

const RITUALS = [
    {
        icon: Moon,
        kicker: "Sám",
        title: "O polnoci v kuchyni",
        desc: "Keď sa nedá spať a všetci ostatní spia. Otvor, otoč hlasitosť myšlienok dole.",
    },
    {
        icon: Users,
        kicker: "S partiou",
        title: "Keď sa všetci pýtajú",
        desc: "Postavíš MAD na stôl. Nikto nepovie nič. Všetci si nalievajú.",
    },
    {
        icon: Music,
        kicker: "Pred niečím",
        title: "Pred dôležitou vecou",
        desc: "Tri minúty pred. Otvor, vypi, odíď. Nepýtaj sa, či to funguje.",
    },
];

export const Ritual = () => {
    return (
        <section
            data-testid="ritual-section"
            className="relative px-6 sm:px-10 py-24 sm:py-32 border-t border-white/10"
        >
            <div className="max-w-[1400px] mx-auto">
                <div className="grid grid-cols-12 gap-10 mb-16">
                    <div className="col-span-12 lg:col-span-3">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C]">
                            03 / Rituál
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-9">
                        <h2
                            data-testid="ritual-heading"
                            className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] text-white"
                        >
                            Kedy si MAD{" "}
                            <span className="text-white/40">otvoriť</span>
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {RITUALS.map((r) => {
                        const Icon = r.icon;
                        return (
                            <div
                                key={r.title}
                                data-testid={`ritual-${r.kicker.toLowerCase()}`}
                                className="group relative bg-[#0A0A0A] border border-white/10 p-8 sm:p-10 hover:bg-black transition-colors overflow-hidden"
                            >
                                {/* Hover red corner accent */}
                                <div className="absolute top-0 right-0 h-16 w-16 bg-[#D91C1C] translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500" />

                                <Icon
                                    size={32}
                                    className="text-[#D91C1C] mb-8 relative z-10"
                                    strokeWidth={1.5}
                                />

                                <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3 relative z-10">
                                    {r.kicker}
                                </div>
                                <h3 className="font-display uppercase text-2xl sm:text-3xl tracking-tight text-white leading-tight relative z-10">
                                    {r.title}
                                </h3>
                                <p className="mt-5 text-white/60 leading-relaxed relative z-10">
                                    {r.desc}
                                </p>

                                {/* Bottom red accent line */}
                                <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-[#D91C1C] group-hover:w-full transition-all duration-500" />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
